import i18n from 'i18next';
import PhraseInContextEditorPostProcessor from 'i18next-phrase-in-context-editor-post-processor';

type I18nAdditionalOptions = {
  phrase?: {
    projectId?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
};

export const defaultLocale = 'en';
export const defaultNamespace = 'translations';

export const options = {
  fallbackLng: defaultLocale,
  ns: [defaultNamespace],
  defaultNS: defaultNamespace,
  debug: false,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
  initAsync: false, // Needed for SSR to work
};
export const ice = {
  fallbackLng: defaultLocale,
  ns: [defaultNamespace],
  defaultNS: defaultNamespace,
  debug: false,
  interpolation: {
    escapeValue: false,
    prefix: '{{',
    suffix: '}}',
  },
  postProcess: ['phraseInContextEditor'],
  react: {
    useSuspense: false,
  },
  initAsync: false, // Needed for SSR to work
  fullReparse: true,
  autoLowercase: false,
};

const isPhraseEnabled = () =>
  typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).has('editPhrase')
    : false;

export default (additionalOptions: I18nAdditionalOptions = {}) => {
  const { phrase = {} } = additionalOptions;
  const { projectId } = phrase;

  if (projectId && isPhraseEnabled()) {
    i18n
      .use(
        new PhraseInContextEditorPostProcessor({
          autoLowercase: false,
          phraseEnabled: true,
          projectId,
        }),
      )
      .init(ice);
  } else {
    i18n.init(options);
  }

  return i18n;
};
